import { LoadingButton } from '@mui/lab';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Stack,
    Button,
    IconButton,
    Typography,
    TextField,
} from '@mui/material';
import { FC, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { ShareIcon } from '../../../vectors/index';
import { useDeleteRockerboxApplicant } from '../hooks/useDeleteRockerboxApplicant';
import { useUploadDocument } from '../hooks/useUploadDocument';

type ShareDocumentModalProps = {
    handleClose: () => void;
    company_id: number;
};

const ShareDocumentModal: FC<ShareDocumentModalProps> = ({
    handleClose,
    company_id,
}) => {
    const [name, setName] = useState('');
    const [documentType, setDocumentType] = useState('');
    const [file, setFile] = useState<File | null>(null);
    const [errorText, setErrorText] = useState('');
    const fileInputRef = useRef<HTMLInputElement>(null);

    const { uploadDocument, isuploadDocumentLoading } = useUploadDocument({ setErrorText });

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
            setDocumentType(e.target.files[0].type); // Optionally set document type from file type
        }
    };

    const handleButtonClick = () => {
        fileInputRef.current?.click();
    };

    const handleSave = () => {
        const options = {
            onSuccess: (data: { message: string }) => {
                toast.success(data.message);
                setName('');
                setDocumentType('');
                setFile(null);
                handleClose();
            },
        };

        uploadDocument({ name: name, rockerbox_document: file, company_id: company_id }, options);
    };

    return (
        <Dialog
            open
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>
                <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                <br />
                <ShareIcon />
                <br />
                <Typography variant="h4">
                    Share Document
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={2}>
                    <Stack>
                        <Typography >
                            Name
                        </Typography>
                        <TextField
                            fullWidth
                            size='small'
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </Stack>
                    <Button
                        variant="outlined"
                        fullWidth
                        onClick={handleButtonClick}
                        sx={{
                            textTransform: 'none'
                        }}
                    >
                        {file ? file.name : 'Upload Document'}
                    </Button>
                    <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                    />
                </Stack>
                <LoadingButton
                    loading={isuploadDocumentLoading}
                    disabled={isuploadDocumentLoading || !file || !name}
                    fullWidth
                    sx={{ marginTop: "10px" }}
                    variant="contained"
                    onClick={handleSave}
                >
                    Upload
                </LoadingButton>
            </DialogContent>
        </Dialog>
    );
};

export default ShareDocumentModal;
